// extracted by mini-css-extract-plugin
export default {"mainContainer":"ChoosedProject_mainContainer__bYQyJ"};